import React from "react";
import TextInput from "../../input/text-input";

const Text1Widget = ({ widget, onValueUpdate }) => {
  const handleValueUpdate = (data) => {
    const updatedWidget = { ...widget, value: data.toString() };
    onValueUpdate(updatedWidget);
  };

  return (
    <div className="flex items-center h-full w-full">
      {widget && (
        <TextInput
          valueSpec={widget}
          onChange={handleValueUpdate}
          style="compact"
        />
      )}
    </div>
  );
};

export default Text1Widget;
